function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import TabColumnView from '@/components/tableau/datasource/TabColumnView';
import TableauDatasourceService from '@/apps/data-platform/services/visualization/tbl_datasource_service';
import tasks from '@/js/tasks';
export default {
  name: 'FormChangeMetaDataDatasource',
  components: {
    TabColumnView: TabColumnView
  },
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    showFooter: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      dismissCountDown: 0,
      dismissSecs: 8,
      dangerMessage: '',
      response_text: '',
      valid_response_text: true,
      fields: [{
        key: 'type',
        label: 'Type',
        class: 'w-15'
      }, {
        key: 'project_name',
        label: 'Project',
        class: 'w-15'
      }, {
        key: 'dataset_name',
        label: 'Dataset',
        class: 'w-15'
      }, {
        key: 'table_name',
        label: 'Table',
        class: 'w-20'
      }],
      filterOriginDs: '',
      filterRequestDs: '',
      objRequestDs: Object,
      objOriginDs: Object,
      diffColumnBd: Object,
      diffColumnBt: Object,
      diffRequest: Object,
      diffRequestDs: Object,
      diffConnectionsDs: Object,
      keyTableRequest: 0,
      tab: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['selectDomain', 'selectSubdomain'])), {}, {
    rowClass: function rowClass() {
      var _this = this;
      return function (item, type) {
        if (!item || type !== 'row') return;
        return item.table_name in _this.diffConnectionsDs ? 'resaltador' : '';
      };
    }
  }),
  beforeMount: function beforeMount() {
    this.onTableauOwnerDs();
  },
  methods: {
    onTableauOwnerDs: function onTableauOwnerDs() {
      var _this2 = this;
      this.objRequestDs = _objectSpread({}, this.item.objectReference);
      this.objRequestDs.request_id = this.item.id;
      this.objRequestDs.applicant = this.item.applicant;
      this.objRequestDs['document_id'] = this.item.table_id;
      this.objOriginDs = {};
      this.diffColumnBdDs = {};
      this.diffColumnBtDs = {};
      this.diffConnectionsDs = {};
      var columns = [];
      this.item.fields.forEach(function (element, index) {
        columns.push(_objectSpread({}, element[index]['fields']));
      });
      this.objRequestDs['columns'] = columns;
      var data = {
        domain: window.userInfo.domain,
        clauses: {
          document_id: this.item.table_id
        }
      };
      TableauDatasourceService.tableauDataSourceQuery(data).then(function (res) {
        console.log(res);
        if (res.code === 200) {
          _this2.objOriginDs = _objectSpread({}, res.data.result);
          for (var i in _this2.objOriginDs) {
            if (_this2.objOriginDs[i] !== _this2.objRequestDs[i]) {
              if (typeof _this2.objOriginDs[i] === 'string') {
                _this2.diffRequestDs["".concat(i)] = true;
              } else if (_typeof(_this2.objOriginDs[i]) === 'object') {
                for (var j in _this2.objOriginDs[i]) {
                  var a = _objectSpread({}, _this2.objOriginDs[i][j]);
                  var b = _objectSpread({}, _this2.objRequestDs[i][j]);
                  if (a.business_definition !== b.business_definition) {
                    _this2.diffColumnBdDs["".concat(a.name)] = true;
                  }
                  if (a.business_term !== b.business_term) {
                    _this2.diffColumnBtDs["".concat(a.name)] = true;
                  }
                }
              }
            }
          }
          var connectionsArray = _this2.objRequestDs.tables.filter(function (table) {
            return _this2.objOriginDs.tables.findIndex(function (item) {
              return item.table_name === table.table_name;
            }) === -1;
          });
          connectionsArray.forEach(function (item) {
            _this2.diffConnectionsDs[item.table_name] = true;
          });
          _this2.keyTableRequest = _this2.keyTableRequest + 1;
        }
      });
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    onCloseModal: function onCloseModal() {
      var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$emit('onCloseModal', reload);
    },
    onAccept: function onAccept() {
      var _this3 = this;
      if (this.response_text.trim() === '') {
        this.valid_response_text = false;
        this.dangerMessage = 'Please complete Message to reply';
        this.dismissCountDown = this.dismissSecs;
        return;
      }
      var data = _objectSpread(_objectSpread({
        response_text: this.response_text,
        domain: window.userInfo.domain
      }, this.objRequestDs), {}, {
        status: 'APPROVED',
        type_flow: 'CHANGE_METADATA'
      });
      TableauDatasourceService.tableauDataSourceSendAssignment(data).then(function (res) {
        if (res.code === 200 && res.success) {
          tasks.toast.success("Solicitud aceptada correctamente.");
          _this3.onCloseModal(true);
        } else {
          tasks.toast.error(res.message);
        }
      });
    },
    onReject: function onReject() {
      var _this4 = this;
      if (this.response_text.trim() === '') {
        this.valid_response_text = false;
        this.dangerMessage = 'Please complete Message to reply';
        this.dismissCountDown = this.dismissSecs;
        return;
      }
      var data = _objectSpread(_objectSpread({
        response_text: this.response_text,
        domain: window.userInfo.domain
      }, this.objRequestDs), {}, {
        status: 'REJECTED',
        type_flow: 'CHANGE_METADATA'
      });
      TableauDatasourceService.tableauDataSourceSendAssignment(data).then(function (res) {
        if (res.code === 200 && res.success) {
          tasks.toast.success("Solicitud rechazada correctamente.");
          _this4.onCloseModal(true);
        } else {
          tasks.toast.error(res.message);
        }
      });
    }
  }
};